import { useEffect } from 'react';
import NProgress from 'nprogress';
import { Box, CircularProgress } from '@mui/material';

function SuspenseLoader() {
  useEffect(() => {
    //NProgress.start();

    return () => {
      //NProgress.done();
    };
  }, []);

  return (
    <Box
      sx={{ position: 'fixed', left: 0, top: 0, width: '100%', height: '100%', backgroundColor: 'rgba(242,245,249,0.50)', zIndex: 5 }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress size={75} disableShrink thickness={4} />
    </Box>
  );
}

export default SuspenseLoader;
